// The project_details.status enum. Colours group the ten values into the four
// phases of a project's life so a glance at the colour is already meaningful:
// offer (purple/teal/rose), work (gray/blue/orange), delivery (indigo/green/red),
// and cancelled (gray).
export const PROJECT_STATUSES = [
  "Offered by Client",
  "Offer Accepted",
  "Offer Rejected",
  "Draft",
  "In Progress",
  "Hold",
  "Submitted",
  "Submission Accepted",
  "Submission Rejected",
  "Cancelled",
];

const STYLES = {
  "Offered by Client":   { badge: "bg-purple-100 text-purple-700", dot: "bg-purple-500", text: "text-purple-700", rail: "border-l-purple-400" },
  "Offer Accepted":      { badge: "bg-teal-100 text-teal-700",     dot: "bg-teal-500",   text: "text-teal-700",   rail: "border-l-teal-400" },
  "Offer Rejected":      { badge: "bg-rose-100 text-rose-700",     dot: "bg-rose-500",   text: "text-rose-700",   rail: "border-l-rose-400" },
  Draft:                 { badge: "bg-gray-100 text-gray-600",     dot: "bg-gray-400",   text: "text-gray-500",   rail: "border-l-gray-300" },
  "In Progress":         { badge: "bg-brand-100 text-brand-700",     dot: "bg-brand-500",   text: "text-brand-700",   rail: "border-l-brand-400" },
  Hold:                  { badge: "bg-orange-100 text-orange-700", dot: "bg-orange-500", text: "text-orange-700", rail: "border-l-orange-400" },
  Submitted:             { badge: "bg-indigo-100 text-indigo-700", dot: "bg-indigo-500", text: "text-indigo-700", rail: "border-l-indigo-400" },
  "Submission Accepted": { badge: "bg-green-100 text-green-700",   dot: "bg-green-500",  text: "text-green-700",  rail: "border-l-green-400" },
  "Submission Rejected": { badge: "bg-danger-100 text-danger-700",       dot: "bg-danger-500",    text: "text-danger-700",    rail: "border-l-danger-400" },
  Cancelled:             { badge: "bg-gray-200 text-gray-500",     dot: "bg-gray-300",   text: "text-gray-400",   rail: "border-l-gray-300" },
};

const FALLBACK = {
  badge: "bg-gray-100 text-gray-700",
  dot: "bg-gray-400",
  text: "text-gray-500",
  rail: "border-l-gray-200",
};

export const projectStatusStyle = (status) => STYLES[status] || FALLBACK;
